import Ext from "Ext";
import GroupSelectorSwitcher from "./at_group_selector_switcher";
import messageResource from "../../messageResource";

const ExtendedGroupSelectorSwitcher = Ext.extend(GroupSelectorSwitcher, {

    init: function(userGroupsEnabled, timeZoneGroupsEnabled, groupByUserCallback, groupByUserGroupCallback, groupByTimeZoneGroupCallback)
    {
        this.groupByUserCallback = groupByUserCallback;
        ExtendedGroupSelectorSwitcher.superclass.init.call(this, userGroupsEnabled, timeZoneGroupsEnabled, groupByUserGroupCallback,
                groupByTimeZoneGroupCallback);
    },

    addComponents: function()
    {
        if (this.userGroupsEnabled && this.timeZoneGroupsEnabled)
        {
            this.addSortByUserLink();
            this.addSeparator("nearByUsers");
            this.addSortByUserGroupLink();
            this.addSeparator("betweenGroups");
            this.addSortByTimeZoneGroupLink();
        }
        else if (this.userGroupsEnabled)
        {
            this.addSortByUserLink();
            this.addSortByUserGroupLink();
        }
        else if (this.timeZoneGroupsEnabled)
        {
            this.addSortByUserLink();
            this.addSortByTimeZoneGroupLink();
        }
        else
        {
            this.addTextPanel(messageResource.getMessage("user_selector.group_by.by_users") + ":");
        }
    },

    addSortByUserLink: function()
    {
        this.addSortByLink(messageResource.getMessage("user_selector.group_by.by_users"), "userLabel", this.groupByUserCallback);
    },

    addSeparator: function(additionalClass)
    {
        this.add(
                new Ext.BoxComponent({
                    autoEl: {
                        tag: 'div',
                        cls: 'vertical-separator ' + additionalClass
                    }
                })
        );
    },

    updateUI: function(groupType)
    {
        this.removeClass('groupedByUsers');
        if(!groupType)
        {
            this.addClass('groupedByUsers');
        }
        ExtendedGroupSelectorSwitcher.superclass.updateUI.apply(this, arguments);
    },

    getSortByTimeZoneGroupLinkText: function()
    {
        if (!this.userGroupsEnabled)
            return messageResource.getEscapedMessage("user_selector.group_by.by_time_zone_groups");

        return ExtendedGroupSelectorSwitcher.superclass.getSortByTimeZoneGroupLinkText.call(this);
    }

});

Ext.reg("at_extended_group_selector_switcher", ExtendedGroupSelectorSwitcher);

export default ExtendedGroupSelectorSwitcher;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/ExtendedGroupSelectorSwitcher.js